import React, {useContext, useEffect, useState} from 'react';
import Button from 'antd/lib/button';
import {FormContext} from "../../metadata/MDForm";
import {ModelContext} from "../../metadata/ModelSource";
import {env} from "../../../env";
import {PaymentInfoContext} from "../../../context/PaymentInfoProvider";


export const CreditCardButton = ({ attr, url, title }) => {
  const [error, setError] = useState('');
  const { currentPaymentSource, setCurrentPaymentSource } = useContext(PaymentInfoContext);

  const applicationModel = useContext(ModelContext);
  let { setValueByAttr,getValueByAttr, getValue } = useContext(FormContext);

  const onClickHandler = ()=>{
    const config = {
      'paymentConfigId': env.creditCardPaymentConfigId, //env
      'tenant': env.creditCardPaymentTenant, //env
      'apiUrl': env.creditCardPaymentApiUrl, //env
      'carrierCode': getValue('basicPolicy.carrierCd'),
      'companyId': '',
      'customerId': 'CUST-!M2R7UN2uOI3CJarNLk1tJ8+eQj0=',
      // OPTIONAL: should be omitted unless you need to test a preproduction api (local or staging)
      //  default is 'https://payments.iscs.io/'
      'uiDisplayConfirmation': false,
      'featureCustomAddressCollection': true,

      //UI
      'uiAcceptJsButtonText': 'Save Card',
      'uiAcceptJsHeaderText': 'Card Information',
      'uiAcceptJsBillingAddressOptionsJson': '{"show":false, "required":false}',
      'uiSdkAddressButtonText': 'Continue',
      'uiSdkAddressHeaderText': 'Card Billing Address',
      'uiSdkBackgroundColor': 'rgba(0, 0, 0, 0.1)',
      'uiSdkCloseButtonAriaAndTitle': 'Close',
      'uiSdkCloseButtonStyles': '',
      'uiSdkHideLoader': false,
      'uiSdkLoaderText': 'Loading...',
      'uiSdkLoaderColor': '#434958',
    };

    const sdk = GuidewirePayments.createSDK(config);

    // call `sdk.collectAndAssociateCard(callback)` when the user presses an "add CC" button
    sdk.collectAndAssociateCard(result => {
      switch (result.type) {
        case 'ERROR':
          // handle error, since error message from SDK is not user friendly and there is not error code from SDK,
          // so we use this one as general error message
          handlerError('The credit card information you entered is not valid.');
          break;
        case 'CARD_ADDED':
          // not sure if result.debug is available in product env, if not , use result.card and name will not be showing
          const card = result.debug && result.debug.saveCardRequest ? result.debug.saveCardRequest : result.card;
          let cardType = "";
          if (card && card.cardType){
            cardType = card.cardType[0].toUpperCase() + card.cardType.slice(1);
          }
          const creditCardInfo = {
            creditCardTypeCd:cardType,
            expDate:card.expDate.substring(5)+'/'+result.debug.tokenizedCard.expDate.substring(2,4),
            creditCardNumber:card.lastFour,
            name:card.firstName +' ' +  card.lastName,
            customerPaymentProfileId:result.card.id.toString(),
            customerProfileId:result.card.id.toString()
          };
          addPaymentSourceInfoToFormContext(creditCardInfo);
          convertPaymentSources([creditCardInfo],false,true);
          setError('');
          break;
        case 'CANCELED':
          // user canceled
          break;
        case 'CARD_TOKENIZED':
          // only tokenize the card info
          break;
        default:
          console.warn('unexpected response type from payments sdk', result);
      }
    });
  }

  const convertPaymentSources = (data, isPriorPayment=false, isChecked)=>{
    if (!Array.isArray(data)) return;
    data = data.map(d=>({
      ...d,
      isPriorPayment,
      isChecked
    }))
    let paymentSources = currentPaymentSource.map(p=>({...p,isChecked:false}));
    if (isPriorPayment){
      // Prevent add duplicated prior payment into local payment sources
      let tmp = [...paymentSources];
      for (let d of data){
        if (paymentSources.find(p=>p.id === d.id)){
        }else {
          tmp.push(d);
        }
      }
      paymentSources = tmp;
    }else {
      paymentSources = [...paymentSources,...data];
    }

    console.log(paymentSources)

    paymentSources = paymentSources.map((p,i)=>({
      ...p,
      type: 'ExistCard'+i,
      label: p.methodCd === 'ACH' ? 'ACH Bank ' + p.achBankAccountNumber : `CC ${p.creditCardTypeCd} ${p.creditCardNumber}`,
    }))
    console.log(paymentSources)
    setCurrentPaymentSource(paymentSources)
  }

  const addPaymentSourceInfoToFormContext = ({customerPaymentProfileId, customerProfileId, creditCardNumber, creditCardTypeCd})=>{
    setValueByAttr('CustomerPaymentProfileId',customerPaymentProfileId);
    setValueByAttr('CustomerProfileId', customerProfileId);
    setValueByAttr('CreditCardNumber', `${creditCardNumber}`);
    setValueByAttr('CreditCardTypeCd', `${creditCardTypeCd}`);
    applicationModel.setValue('basicPolicy.electronicPaymentSource.paymentServiceAccountId',getValue('basicPolicy.carrierCd'))
  };

  const handlerError = (errorMsg)=>{
    setError(errorMsg);
    setValueByAttr('CustomerPaymentProfileId', '');
    setValueByAttr('CustomerProfileId', '');
    setValueByAttr('CreditCardNumber', '');
    setValueByAttr('CreditCardTypeCd', '');
  }

  return (
    <div>
      <Button type="primary" onClick={onClickHandler} style={{marginBottom:'20px'}}>
        {title}
      </Button>
      {error && <p style={{color:'red'}}>{error}</p>}
    </div>
  );
};
